import React from "react";

import { Container, Row, Col } from "reactstrap";

function JobHunterMalwareHeader() {
  return (
    <div className="header">
      <Container>
        <Row>
          <Col className="mx-auto my-5 text-center" lg="10">
            <h1 className="display-2 text-default">
              Blockchain Job Hunters Being Targeted with Malware
            </h1>
          </Col>
        </Row>
        <Row>
          <div className="floating-box rounded mx-3 bg-default">
            <h2 className="lead text-white p-5">
              I was contacted by a victim who informed me their crypto assets stored in their 
              Ledger hardware wallet had been transferred without the hardware wallet's security 
              features preventing any transactions from taking place.
            </h2>
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default JobHunterMalwareHeader;
